"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormatBetSystemType = exports.getIsHideAmountForTypes = exports.getIsBetWithCurrentSystem = exports.getCommonPossibleWinSum = exports.getBonusCouponPossibleWinSum = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const round_1 = __importDefault(require("lodash/round"));
const getBonusCouponPossibleWinSum = (betAmount, coefficient, loyaltyCurrencyRestriction) => ({
    [betweb_openapi_axios_1.CouponPayoutType.CouponPayout]: betAmount,
    [betweb_openapi_axios_1.CouponPayoutType.WinAmount]: getCouponPayoutTypeWinAmount(betAmount, coefficient, loyaltyCurrencyRestriction),
    [betweb_openapi_axios_1.CouponPayoutType.Unknown]: 0,
});
exports.getBonusCouponPossibleWinSum = getBonusCouponPossibleWinSum;
const getCouponPayoutTypeWinAmount = (betAmount, coefficient, loyaltyCurrencyRestriction) => {
    const amount = coefficient ? (0, round_1.default)(betAmount * (coefficient - 1), 2) : 0;
    const maxPayout = loyaltyCurrencyRestriction === null || loyaltyCurrencyRestriction === void 0 ? void 0 : loyaltyCurrencyRestriction.maxPayout;
    if (maxPayout) {
        return amount > maxPayout ? maxPayout : amount;
    }
    else {
        return amount;
    }
};
const getCommonPossibleWinSum = ({ coefficient, bet, }) => coefficient ? (0, round_1.default)(bet * coefficient, 2) : 0;
exports.getCommonPossibleWinSum = getCommonPossibleWinSum;
const getIsBetWithCurrentSystem = (bet) => bet.betType === betweb_openapi_axios_1.BetType.System && bet.status === betweb_openapi_axios_1.BetStatus.Current;
exports.getIsBetWithCurrentSystem = getIsBetWithCurrentSystem;
const getIsHideAmountForTypes = (bet) => ({
    [betweb_openapi_axios_1.BetType.System]: (0, exports.getIsBetWithCurrentSystem)(bet),
});
exports.getIsHideAmountForTypes = getIsHideAmountForTypes;
const getFormatBetSystemType = (bet) => {
    return (bet === null || bet === void 0 ? void 0 : bet.betType) === betweb_openapi_axios_1.BetType.System
        ? `${bet.systemSize}/${bet.outcomes.length}`
        : '';
};
exports.getFormatBetSystemType = getFormatBetSystemType;
//# sourceMappingURL=index.js.map